import kbl from "./1.webp";
import kbl2 from "./2.webp";
import kbl3 from "./3.webp";

const kblImages = [kbl, kbl2, kbl3];

export default kblImages;
